import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { Features } from '@app/core/user-permissions/user-permissions.model';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { Channel } from '@app/shared/models/channel';
import { ReservationService } from '@app/shared/services/reservation/reservation.service';
import { TasksService } from '@app/shared/services/tasks/tasks.service';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-sidebar-reservation',
  templateUrl: './sidebar-reservation.component.html',
  styleUrls: ['./sidebar-reservation.component.scss'],
})
export class SidebarReservationComponent implements OnInit {
  Channel = Channel;

  @Input() selectedReservation: any;
  @Input() clickedProperty: any;
  @Input() showJumpToBooking = true;

  @Output() close: EventEmitter<boolean> = new EventEmitter();
  @Output() reservationNeedsUpdating: EventEmitter<null> = new EventEmitter();
  @Output() openParentChildReservation: EventEmitter<any> = new EventEmitter();

  perms$ = this.userPermissionsService;
  user = this.auth.getUserDetails();

  shouldShowGuestPortalTasks$ = combineLatest([
    this.perms$.hasAccessTo(Features.PERM_INBOX),
    this.perms$.hasAccessTo(Features.PERM_GUEST_EXPERIENCE),
    this.perms$.hasAccessTo(Features.PERM_RESERVATION_FINANCIALS),
  ]).pipe(
    map(
      ([hasInbox, hasGuestExperience, hasReservationFinancials]) =>
        (hasInbox && hasReservationFinancials) || hasGuestExperience
    )
  );

  Features = Features;

  constructor(
    private userPermissionsService: UserPermissionsService,
    private reservationService: ReservationService,
    private taskService: TasksService,
    private auth: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.fetchTasks();
  }

  ngOnChanges() {
    this.fetchTasks();
  }

  fetchTasks() {
    if (!this.selectedReservation?.thread_uuid) {
      return;
    }

    this.taskService.getTasksForThread(this.selectedReservation.thread_uuid).subscribe((res) => {
      this.selectedReservation.tasks = res;
    });
  }

  taskCreated(newTask) {
    if (!this.selectedReservation.tasks) {
      this.selectedReservation.tasks = [];
    }
    this.selectedReservation.tasks.push(newTask);
  }

  updateTask(newTask) {
    let taskToUpdate = this.selectedReservation.tasks.findIndex((x) => x.uuid === newTask.uuid);

    this.selectedReservation.tasks[taskToUpdate] = newTask;
  }

  deleteTask(uuid: string) {
    let taskToUpdate = this.selectedReservation.tasks.findIndex((x) => x.uuid === uuid);

    this.selectedReservation.tasks.splice(taskToUpdate, 1);
  }

  jumpToMainBookingParentChild() {
    this.openParentChildReservation.emit(this.selectedReservation);
  }
}
